import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ChecklistTemplateListDataService } from './checklist-template-list-data.service';
import { FiChecklistTemplateViewComponent } from './checklist-template-view/checklist-template-view.component';
import { FiAppTextSharedModule } from '@fi-shared/app-text';
import { UtilitiesModule } from '@fi-app/utilities/utilities.module';
import { ChecklistEditModule } from '@fi-app/checklist/edit/edit.module';
import { FormsModule } from '@angular/forms';
import { FiEditorPageModule } from '@fi-app/components/fi-editor-page/fi-editor-page.module';
import { ChecklistTemplateListViewComponent } from './checklist-template-list-view/checklist-template-list-view.component';
import { ComponentsModule } from '@fi-app/components/components.module';
import { UIRouterModule } from '@uirouter/angular';
import { ChecklistTemplateStates } from '@fi-app/checklist-template/checklist-template-states';
import { FiItemsListModule } from '@fi-shared/fi-items-list/fi-items-list.module';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';

@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        UtilitiesModule,
        FiAppTextSharedModule,
        ChecklistEditModule,
        FiEditorPageModule,
        ComponentsModule,
        UIRouterModule.forChild(ChecklistTemplateStates),
        FiItemsListModule,
        MatIconModule,
        MatButtonModule,
    ],
    declarations: [FiChecklistTemplateViewComponent, ChecklistTemplateListViewComponent],
    providers: [ChecklistTemplateListDataService],
})
export class ChecklistTemplateModule {}
